import {Product} from "../../Model/Catalog/Product";
import {EventEmitter, Injectable} from "@angular/core";
import {NextPimField} from "../../Model/Catalog/NextPimField";
import {ExcelElement} from "../../Model/ui/ExcelElement";

@Injectable()
export class NpInputControlContext {
    excelModel: ExcelElement[] | null = null;
    showDragHandle: boolean = false;
    model: Product = new Product();
    productTranslation: Product;
    showLinkButtons: boolean = false;
    selectedElements: string[] = [];
    dragFilter: string;
    isPrint: boolean = false;
    templateView = false;
    showHTMLSwitch = true;
    massDataChangeMode = false;

    valueChanged = new EventEmitter<any>();
    elementSelected = new EventEmitter<string>();
    elementDropped = new EventEmitter<any>();
    elementDelete = new EventEmitter<any>();
    pimFieldReordered = new EventEmitter<string>();
    pimFieldCleared = new EventEmitter<NextPimField>();
    pimFieldTemplateItemRemoved = new EventEmitter<{ field: NextPimField, templateItemTitle: string }>();
    translationUpdate = new EventEmitter<any>();
    selectedElementsChanged = new EventEmitter<boolean>();

    templateUpdated = new EventEmitter<any>();
}